/*
 *  全局定义信息
 *
 *  @author penghj
 *  @site https://www.jeepay.vip
 *  @date 2021/5/8 07:18
 */

const errorPageRouteName = 'Error' //错误页面名称定义
const passGuardRouteList = [errorPageRouteName]  // 不进入路由守卫的name

/** 定义支付方式 **/
const payWay = {
    WXPAY: {wayCode: "WX_JSAPI", routeName: "CashierWxpay", channel: "wx"},
    ALIPAY: {wayCode: "ALI_JSAPI", routeName: "CashierAlipay", channel: "ali"},
    YSFPAY : {wayCode: "YSF_JSAPI", routeName: "CashierYsfpay"}
}

const qrcType = {
		QR_CASHIER: {code: "QR_CASHIER"},
    QRC_STATIC: {code: "QR_SCAN"},
    ALIPAY: {wayCode: "ALI_JSAPI", routeName: "CashierAlipay"}
}

export default {
    errorPageRouteName: errorPageRouteName,
    passGuardRouteList: passGuardRouteList,
    urlTokenName: "lxpayToken", //URL传递的token名称
    payWay: payWay,
    qrcType: qrcType,
    cacheToken: ""
}

